import compilePath from './compilePath';
import { IRoutePage, IRoutePageWithPathParams } from '../types';

function createPathParams(keys, values: string[]) {
  return keys.reduce((result, key, i) => {
    result[key.name] = values[i];
    return result;
  }, {});
}

function matchRoute(
  routes: IRoutePage[],
  routeState: string,
): IRoutePageWithPathParams {
  // TODO
  /* eslint-disable @typescript-eslint/prefer-for-of */
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i];
    const compiledPath = compilePath(route.path);
    const match = compiledPath.pattern.exec(routeState);

    if (match) {
      const values = match.slice(1);
      const params = createPathParams(compiledPath.keys, values);
      return {
        ...route,
        params,
      };
    }
  }
}

export default matchRoute;
